import { drawDisguiseLogo } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const testCard: InputSource = {
  label: 'Test Card',
  value: 'testCard',
  draw: (ctx, width, height) => {
    ctx.clearRect(0, 0, width, height);

    // --- Row heights as fractions ---
    const row1H = Math.round(height * 0.38); // Color bars
    const row2H = Math.round(height * 0.12); // Complementary bars
    const row3H = Math.round(height * 0.16); // Grayscale ramp
    const row4H = Math.round(height * 0.1); // Rainbow gradient
    const row5H = Math.round(height * 0.08); // Purple stripes
    const row6H = height - row1H - row2H - row3H - row4H - row5H; // Full range

    let y = 0;

    // --- Row 1: Primary color bars ---
    const bars = ['#ffffff', '#ffff00', '#00ffff', '#00ff00', '#ff00ff', '#ff0000', '#0000ff'];
    const barW = width / bars.length;
    for (let i = 0; i < bars.length; i++) {
      ctx.fillStyle = bars[i];
      ctx.fillRect(i * barW, y, barW + 1, row1H);
    }

    // Disguise logo overlay (centered black box)
    const logoBoxW = Math.round(width * 0.35);
    const logoBoxH = Math.round(row1H * 0.22);
    const logoBoxX = Math.round((width - logoBoxW) / 2);
    const logoBoxY = y + Math.round((row1H - logoBoxH) / 2);
    ctx.fillStyle = '#000000';
    ctx.fillRect(logoBoxX, logoBoxY, logoBoxW, logoBoxH);
    drawDisguiseLogo(ctx, logoBoxW, logoBoxH, logoBoxX, logoBoxY);

    y += row1H;

    // --- Row 2: Complementary / reverse bars ---
    const compBars = ['#0000ff', '#ff00ff', '#ffff00', '#ff0000', '#00ffff', '#000000', '#ffffff'];
    for (let i = 0; i < compBars.length; i++) {
      ctx.fillStyle = compBars[i];
      ctx.fillRect(i * barW, y, barW + 1, row2H);
    }
    y += row2H;

    // --- Row 3: Grayscale ramp with percentage labels ---
    const steps = 11;
    const stepW = width / steps;
    for (let i = 0; i < steps; i++) {
      const t = i / (steps - 1);
      const v = Math.round(t * 255);
      ctx.fillStyle = `rgb(${v},${v},${v})`;
      ctx.fillRect(i * stepW, y, stepW + 1, row3H);
    }

    // Percentage labels
    const fontSize = Math.max(8, Math.round(height * 0.014));
    ctx.font = `${fontSize}px Arial, sans-serif`;
    ctx.textBaseline = 'bottom';
    for (let i = 0; i < steps; i++) {
      const pct = 100 - i * 10;
      const labelX = i * stepW + 4;
      const labelY = y + row3H - 4;
      // Contrast text color
      ctx.fillStyle = i < steps / 2 ? '#ffffff' : '#000000';
      ctx.textAlign = 'left';
      ctx.fillText(`${pct}%`, labelX, labelY);
    }
    y += row3H;

    // --- Row 4: Rainbow hue gradient ---
    for (let x = 0; x < width; x++) {
      const hue = (x / width) * 360;
      ctx.fillStyle = `hsl(${hue}, 100%, 50%)`;
      ctx.fillRect(x, y, 2, row4H);
    }
    y += row4H;

    // --- Row 5: Purple / magenta vertical stripes ---
    const stripeW = Math.max(2, Math.round(width * 0.006));
    for (let x = 0; x < width; x += stripeW * 2) {
      ctx.fillStyle = '#8b00ff';
      ctx.fillRect(x, y, stripeW, row5H);
      ctx.fillStyle = '#4a0080';
      ctx.fillRect(x + stripeW, y, stripeW, row5H);
    }
    y += row5H;

    // --- Row 6: Full Range (white left, black right) ---
    const halfW = Math.round(width / 2);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, y, halfW, row6H);
    ctx.fillStyle = '#000000';
    ctx.fillRect(halfW, y, width - halfW, row6H);

    // "Full Range" labels
    const frFontSize = Math.max(10, Math.round(height * 0.025));
    ctx.font = `${frFontSize}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const labelCY = y + row6H / 2;

    ctx.fillStyle = 'rgba(180, 180, 180, 0.7)';
    ctx.fillText('Full Range', halfW / 2, labelCY);

    ctx.fillStyle = 'rgba(100, 100, 100, 0.7)';
    ctx.fillText('Full Range', halfW + (width - halfW) / 2, labelCY);
  },
};
